module.exports = __webpack_public_path__ + "img/logo_color.a28a9bbe.svg";